<template>
  <q-dialog
    :visible="isVisible"
    title="调整记录"
    width="40%"
    :innerScroll="false"
    :showFooter="false"
    @close="onClose"
  >
    <el-table
      :data="positioningData"
      v-loading="loading"
      border
      :height="300"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      :header-cell-style="{
        backgroundColor: '#FAFAFA',
        textAlign: 'center',
      }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
    >
      <el-table-column
        prop="afterModify"
        label="处理意见"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="createdBy"
        label="操作人"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="createdDate"
        label="操作时间"
        :show-overflow-tooltip="true"
      ></el-table-column>
    </el-table>
  </q-dialog>
</template>

<script>
export default {
  name: 'AdjustRecordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      loading: false,
      positioningData: []
    }
  },
  watch: {
    visible(val) {
      if (val && this.row) {
        this.fetchData()
      }
    }
  },
  methods: {
    onClose() {
      this.isVisible = false
    },
    fetchData() {
      let data = {
        bigModel: this.row.bigModel,
        productCategory: this.row.categoryName,
      }
      this.loading = true
      this.$q.productModelDetails
        .queryBigModelHandlingCommentsRecord({ data: data })
        .then((res) => {
          if (res.code === '200') {
            this.positioningData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
